import { orchestrator } from 'satcheljs';
import { isCapabilityEnabled } from 'owa-capabilities';
import { newHeaderCapability } from 'owa-capabilities-definitions/lib/newHeaderCapability';
import { hasActiveDrawerPane } from 'owa-drawer';
import { setIsFlexPaneShown } from 'owa-suite-header-store';
import { onAvailableWidthBucketChanged } from '../actions/onAvailableWidthBucketChanged';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import calculateAvailableWidthBucket from '../utils/calculateAvailableWidthBucket';
import { updateFlexPaneInternalWidth } from '../utils/updateFlexPaneInternalWidth';
import { getAreDisplayAdsEnabled } from '../selectors/getAreDisplayAdsEnabled';
import { setBrowserWidthBucket } from '../actions/setAvailableHeightAndWidthBuckets';

orchestrator(setIsFlexPaneShown, actionMessage => {
    const isNewHeaderEnabled = isCapabilityEnabled(newHeaderCapability);
    const shouldSubtractFlexPaneWidth =
        (isNewHeaderEnabled && hasActiveDrawerPane()) ||
        (!isNewHeaderEnabled && actionMessage.isShown);

    const newAvailableWidthBucket = calculateAvailableWidthBucket(
        false /* skipCache */,
        getAreDisplayAdsEnabled(),
        shouldSubtractFlexPaneWidth /* isShown */
    );
    setBrowserWidthBucket(newAvailableWidthBucket);

    if (!isNewHeaderEnabled || (isNewHeaderEnabled && actionMessage.isShown)) {
        updateFlexPaneInternalWidth();
    }

    onAvailableWidthBucketChanged(
        newAvailableWidthBucket,
        LayoutChangeSource.OwaSuiteHeaderFlexPane
    );
});
